<template>
    <router-view/>
</template>

<script>

import store from './store/store'

export default {
  name: 'App',
  created() {
    store.commit("tai",this.$route.query.tai);
  }
}
</script>

